export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_VENTES = 'SET_CRITERE_VENTES';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_CRITERE_PREVISIONNEL = 'SET_CRITERE_PREVISIONNEL';
export const SET_CRITERE_PREVISIONNEL_CBA = 'SET_CRITERE_PREVISIONNEL_CBA';
export const SET_CRITERE_ACHATS = 'SET_CRITERE_ACHATS';
